import React from "react";

const steps = [
  {
    id: (
      <svg
        width="65"
        height="66"
        viewBox="0 0 65 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.689941"
          width="65"
          height="65"
          rx="32.5"
          fill="#1E90FF"
          fill-opacity="0.1"
        />
        <path
          d="M28.216 24.2099V21.5539H34.232V44.6899H31.288V24.2099H28.216Z"
          fill="#1E90FF"
        />
      </svg>
    ),
    title: "List your car",
    desc: "Tell us about your car's year, make, model, and condition. We'll take care of professional photos and an attractive listing.",
    isActive: false,
  },
  {
    id: (
      <svg
        width="65"
        height="66"
        viewBox="0 0 65 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.689941"
          width="65"
          height="65"
          rx="32.5"
          fill="#1E90FF"
          fill-opacity="0.1"
        />
        <path
          d="M24.632 41.664C27.3413 39.488 29.464 37.7067 31 36.32C32.536 34.912 33.8267 33.4507 34.872 31.936C35.9387 30.4 36.472 28.896 36.472 27.424C36.472 26.0373 36.1307 24.9493 35.448 24.16C34.7867 23.3493 33.7093 22.944 32.216 22.944C30.7653 22.944 29.6347 23.4027 28.824 24.32C28.0347 25.216 27.608 26.4213 27.544 27.936H24.728C24.8133 25.5467 25.5387 23.7013 26.904 22.4C28.2693 21.0987 30.0293 20.448 32.184 20.448C34.3813 20.448 36.12 21.056 37.4 22.272C38.7013 23.488 39.352 25.1627 39.352 27.296C39.352 29.0667 38.8187 30.7947 37.752 32.48C36.7067 34.144 35.512 35.616 34.168 36.896C32.824 38.1547 31.1067 39.6267 29.016 41.312H40.024V43.744H24.632V41.664Z"
          fill="#1E90FF"
        />
      </svg>
    ),
    title: "Relax and earn",
    desc: "We manage bookings, screen renters, and ensure your car is covered with top-tier insurance.",
    isActive: true, // Middle card highlighted
  },
  {
    id: (
      <svg
        width="65"
        height="66"
        viewBox="0 0 65 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.689941"
          width="65"
          height="65"
          rx="32.5"
          fill="#1E90FF"
          fill-opacity="0.1"
        />
        <path
          d="M24.92 26.688C25.0693 24.7253 25.8267 23.1893 27.192 22.08C28.5573 20.9707 30.328 20.416 32.504 20.416C33.9547 20.416 35.2027 20.6827 36.248 21.216C37.3147 21.728 38.1147 22.432 38.648 23.328C39.2027 24.224 39.48 25.2373 39.48 26.368C39.48 27.6907 39.096 28.832 38.328 29.792C37.5813 30.752 36.6 31.3707 35.384 31.648V31.808C36.7707 32.1493 37.8693 32.8213 38.68 33.824C39.4907 34.8267 39.896 36.1387 39.896 37.76C39.896 38.976 39.6187 40.0747 39.064 41.056C38.5093 42.016 37.6773 42.7733 36.568 43.328C35.4587 43.8827 34.1253 44.16 32.568 44.16C30.3067 44.16 28.4507 43.5733 27 42.4C25.5493 41.2053 24.7387 39.52 24.568 37.344H27.384C27.5333 38.624 28.056 39.6693 28.952 40.48C29.848 41.2907 31.0427 41.696 32.536 41.696C34.0293 41.696 35.16 41.312 35.928 40.544C36.7173 39.7547 37.112 38.7413 37.112 37.504C37.112 35.904 36.5787 34.752 35.512 34.048C34.4453 33.344 32.8347 32.992 30.68 32.992H29.944V30.56H30.712C32.6747 30.5387 34.1573 30.2187 35.16 29.6C36.1627 28.96 36.664 27.9787 36.664 26.656C36.664 25.5253 36.2907 24.6187 35.544 23.936C34.8187 23.2533 33.7733 22.912 32.408 22.912C31.0853 22.912 30.0187 23.2533 29.208 23.936C28.3973 24.6187 27.9173 25.536 27.768 26.688H24.92Z"
          fill="#1E90FF"
        />
      </svg>
    ),
    title: "Get paid monthly",
    desc: "Receive a direct deposit every month for your car's earnings, minus a small commission fee.",
    isActive: false,
  },
];

const HowItWorks: React.FC = () => {
  return (
    <div className="py-16 bg-[#F5F5F7]">
      {/* Title */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold">How It Works</h2>
      </div>

      {/* Steps Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 mx-12 lg:mx-24">
        {steps.map((step) => (
          <div
            className={`p-8 rounded-xl border border-primary-100 text-left transition-all duration-300 max-w-sm `}
          >
            <div
              className={`w-12 h-12 flex items-start justify-center rounded-full text-primary-100 mb-4 font-bold text-lg `}
            >
              {step.id}
            </div>
            <h3 className="text-xl font-semibold">{step.title}</h3>
            <p className="text-sm mt-2">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
